import { html } from '@design.estate/dees-element';
import { demoPage, demoSection } from '../../../demos/templates.js';
import type { IHarnessTodoItem } from '../interfaces.js';

const demoTodos: IHarnessTodoItem[] = [
  { id: 't1', content: 'Pin sitemap cache key to the route manifest hash', status: 'completed' },
  { id: 't2', content: 'Add regression test for locale rollouts', status: 'completed' },
  { id: 't3', content: 'Wire the deploy pipeline to the new cache key', status: 'in_progress' },
  { id: 't4', content: 'Verify staging deploy timings against baseline', status: 'pending' },
  { id: 't5', content: 'Roll out to production', status: 'pending' },
];

export const demoFunc = () => demoPage('Tasks', 'Progress that stays readable alongside the conversation.', html`
  <div class="dees-demo-grid">
    ${demoSection('In progress', 'Completed and remaining work.', html`
      <dees-harness-todos heading="Current tasks" .todos=${demoTodos}></dees-harness-todos>`)}
    ${demoSection('Ready for a task', 'An empty list before work begins.', html`
      <dees-harness-todos heading="Current tasks"></dees-harness-todos>`)}
  </div>
`);
